<div class="faq-container">
  <div class="row child-container-one">
    @if (faq) {
      <section class="col-xl-8 col-lg-8 col-12 leftSection">
        @if (baseSiteId == 'vsh') {
          <div class="col">Find fast answers to common questions about how to use VaccineShop.com.</div>
        }
        @if (baseSiteId == 'vax') {
          <div class="col">Find fast answers to common questions about how to use VaxServe.com.</div>
        }
        @for (f of faq; track f; let i = $index) {
          <mat-accordion #accordions [multi]="true">
            <mat-expansion-panel #outerPanel hideToggle [ngClass]="panelOpenState? '' : 'border-bottom'"
              (opened)="panelOpenState = true" (closed)="panelOpenState = false" class="outerPanel">
              <mat-expansion-panel-header class="mt-2 mb-2" [ngClass]="i == 0 ? 'mt-4' : 'mt-2'">
                <mat-panel-title class="categoryName" (click)="$event.stopPropagation();">
                  {{ f.item }}
                </mat-panel-title>
                <p class="align-middle alignAllText">
                  <span (click)="showOnlyQuestions(i)">+/-</span>
                  <span class="ml-1" (click)="toggle(i)">All</span>
                </p>
              </mat-expansion-panel-header>
              @for (q of f.questions; track q; let j = $index) {
                <mat-expansion-panel class="innerPanel border-bottom" #panel (opened)="panelOpenState = true"
                  (closed)="panelOpenState = false" [expanded]="q.open"
                  hideToggle>
                  <mat-expansion-panel-header class="p-0" [ngClass]="j==0 ? 'border-top' : '' ">
                    <mat-panel-title class="question" (click)="$event.stopPropagation();">
                      {{ q.question }}
                    </mat-panel-title>
                    @if (!panel.expanded) {
                      <img src="/icons/{{baseSiteId}}/plus-green.png"
                        class="openPanelIcon">
                    }
                    @if (panel.expanded) {
                      <img src="/icons/{{baseSiteId}}/minus-green.png"
                        class="closePanelIcon">
                    }
                  </mat-expansion-panel-header>
                  <p class="answer">
                    <app-accordian-answers [answers]="q.answer"></app-accordian-answers>
                  </p>
                </mat-expansion-panel>
              }
            </mat-expansion-panel>
          </mat-accordion>
        }
      </section>
    }
    <aside class="col-xl-4 col-lg-4 col-12 medium pl-0 right-navigation">
      <div class="col-md-6 col-sm-6 col-lg-12 col-xl-12 quick_link ml-3 mt-3">
        <h3>Quick links</h3>
        <div class="mt-4">
          <div class="content">
            <div class=""><a (click)="goToPatientEducation()" title="" target="">Vaccination solutions &amp; patient
            education</a>
            <p>Discover Immunization planning resources, as well as our library of downloadable posters, brochures,
            social posts and more.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col col-md-6 col-sm-6 col-lg-12 col-xl-12 content needAssistance">
      <div class="ml-3 mt-3">
        <span class="Need-assistance">Need assistance?</span>
        <div class="Contact-support">
          <span>Contact our support center</span>
          <span>Monday - Friday</span>
          <span class="support-time">8:30 AM - 5:00 PM (ET)</span>
        </div>
        <div class="Contact-details">
          <span>
            <img src="/icons/{{baseSiteId}}/phone.svg" alt="phone">
          </span>
          @if (baseSiteId == 'vsh') {
            <span>1-800-VACCINE (1-800-822-2463)</span>
          }
          @if (baseSiteId == 'vax') {
            <span>1-800-752-9338</span>
          }
        </div>
        <div class="Contact-details">
          <span>
            <img src="/icons/{{baseSiteId}}/mail-new.svg" alt="email">
          </span>
          @if (baseSiteId == 'vsh') {
            <span>
              <a href="mailto:vaccineshoppe.svc@sanofi.com">{{vshEmail}}</a>
            </span>
          }
          @if (baseSiteId == 'vax') {
            <span>
              <a href="mailto:VaxServe@vaxserve.com">{{vaxEmail}}</a>
            </span>
          }
        </div>
      </div>
    </div>
  </aside>
</div>
</div>
